import { BriefcaseEyeIcon } from './BriefcaseEyeIcon';

/**
 * author: Michael Irigoyen
 * id 15362BD1-6DB7-4334-B6CF-35A61D7EE2A0
 * name briefcase-eye
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/briefcase-eye.svg
 * tags
 */
export const BriefcaseViewIcon = BriefcaseEyeIcon;
export default BriefcaseViewIcon